<sales-ui-meddic-progress-bar
  [scores]="scores$ | async"
  [loading]="scoresState.isLoading$ | async"
></sales-ui-meddic-progress-bar>

<sales-ui-meddic-errors
  [hasError]="isFailed$ | async"
  [errorMessage]="'MEDDIC.PROBLEM_SAVING_SCORES' | translate"
  [retrying]="isSending$ | async"
  (retryRequest)="saveMEDDICScores()"
></sales-ui-meddic-errors>
<sales-ui-meddic-errors
  [hasError]="(notesSavedSuccessfully$ | async) === false"
  [errorMessage]="'MEDDIC.PROBLEM_SAVING_NOTES' | translate"
  [retrying]="notesAreSaving$ | async"
  (retryRequest)="retrySavingMEDDICNotes()"
></sales-ui-meddic-errors>
<sales-ui-meddic-errors
  [hasError]="(getSectionsState.isSuccess$ | async) === false"
  [errorMessage]="'MEDDIC.PROBLEM_LOADING_NOTES' | translate"
  [retrying]="getSectionsState.isLoading$ | async"
  (retryRequest)="retryGettingMEDDICSections()"
></sales-ui-meddic-errors>

<mat-accordion>
  <ng-container
    *ngTemplateOutlet="
      scorepannel;
      context: { section: MEDDIC_METRICS_SECTION, scoreI18nKey: 'METRIC', scoresKey: 'metric' }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      scorepannel;
      context: { section: MEDDIC_ECONOMIC_BUYER_SECTION, scoreI18nKey: 'ECONOMIC_BUYER', scoresKey: 'economicBuyer' }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      scorepannel;
      context: {
        section: MEDDIC_DECISION_CRITERIA_SECTION,
        scoreI18nKey: 'DECISION_CRITERIA',
        scoresKey: 'decisionCriteria'
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      scorepannel;
      context: {
        section: MEDDIC_DECISION_PROCESS_SECTION,
        scoreI18nKey: 'DECISION_PROCESS',
        scoresKey: 'decisionProcess'
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      scorepannel;
      context: { section: MEDDIC_PAPER_PROCESS_SECTION, scoreI18nKey: 'PAPER_PROCESS', scoresKey: 'paperProcess' }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      scorepannel;
      context: { section: MEDDIC_IDENTIFY_PAIN_SECTION, scoreI18nKey: 'IDENTIFY_PAIN', scoresKey: 'identifyPain' }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      scorepannel;
      context: { section: MEDDIC_CHAMPION_SECTION, scoreI18nKey: 'CHAMPION', scoresKey: 'champion' }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      scorepannel;
      context: { section: MEDDIC_COMPETITION_SECTION, scoreI18nKey: 'COMPETITION', scoresKey: 'competition' }
    "
  ></ng-container>
</mat-accordion>
<ng-template #scorepannel let-section="section" let-scoreI18nKey="scoreI18nKey" let-scoresKey="scoresKey">
  <mat-expansion-panel>
    <mat-expansion-panel-header collapsedHeight="60px">
      <sales-ui-meddic-title
        [scoreI18nKey]="scoreI18nKey"
        [scoresKey]="scoresKey"
        [scoresState]="scoresState"
      ></sales-ui-meddic-title>
    </mat-expansion-panel-header>
    <sales-ui-meddic-selector
      [scoreI18nKey]="scoreI18nKey"
      [scoresKey]="scoresKey"
      [scores]="scores$ | async"
      (scoresChanged)="handleScoresChanged($event)"
    ></sales-ui-meddic-selector>
    <div class="notes-field">
      <sales-ui-meddic-notes-field
        [opportunityId]="opportunityId$ | async"
        [accountGroupId]="accountGroupId$ | async"
        [section]="section"
        [fallbackSalespersonId]="fallbackSalespersonId$ | async"
      ></sales-ui-meddic-notes-field>
    </div>
  </mat-expansion-panel>
</ng-template>
